import React from "react";
import { FaFacebookSquare, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import Logo from "../../assets/images/logo.svg";
import MailIcon from "../../assets/images/mail-icon.svg";

const Footer = () => {
  return (
    <footer className="w-full">

      {/* <div className="  bg-[#F6E0E1] max-w-full px-6 lg:px-20 py-4 flex flex-col lg:flex-row items-center newsLetter">
        <div className="flex flex-col mb-4 lg:mb-0 lg:mr-auto">
          <span className="text-lg font-bold newsletter-head">Newsletter</span>
          <span className="newsfoot">
            Be the first one to know about discounts, offers and events
          </span>
        </div>

        <div className="flex ml-auto newsletter">
          <form
            action=""
            className="flex rounded-26 items-center w-full lg:w-96"
          >
            <div className="flex items-center justify-between newsletterSubmit rounded-full w-full lg:w-96 ">
              <div className="flex gap-2 items-center icon-input">
                <img src={MailIcon} alt="Email" className="h-4" />
                <input
                  className="Footer-news bg-transparent w-full text-sm placeholder:text-black"
                  type="email"
                  placeholder="Enter your Email" 
                />
              </div>
              <button
                type="button"
                className="  w-20 h-8 rounded-full border-none bg-white text-[#ED1C25] text-xs font-semibold cursor-pointer"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div> */}


      <div className="mx-auto max-w-full px-6 lg:px-20 flex flex-col lg:flex-row items-start space-x-6 md:space-x-14 footer-bottom">

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-0 mt-10 lg:mt-0">
          <div className="lg:pr-4 footer-logo mb-2">
            <img src={Logo} alt="Logo" className="h-16" />
            <p className="mt-4 text-sm">

              <a href="https://www.thecage.com.sg/">www.thecage.com.sg</a>
            </p>
          </div>
          <div className="mb-0 lg:mb-0">
            <h4 className="mb-2">Company</h4>
            <ul>
              <li>

                <a href="https://www.thecage.com.sg/about-us/" className="mx-2">

                  About us
                </a>

              </li>

              <li>
                <a href="https://www.thecage.com.sg/blog/" className="mx-2">
                  Blogs
                </a>

              </li>
            </ul>
          </div>
          <div className="mb-0 lg:mb-0">
            <h4 className="mb-2">HELP CENTER</h4>
            <ul>
              <li>
                <a href="https://www.thecage.com.sg/venue/" className="mx-2">
                  Find a Venue
                </a>

              </li>

              <li>
                <a href="https://www.thecage.com.sg/booking-guide/" className="mx-2">
                  Booking Guides
                </a>

              </li>
            </ul>
          </div>

          <div className="mb-2 lg:mb-0">
            <h4 className="mb-2">Contact Info</h4>
            <ul className="text-gray-600">
              <li>Phone: 65634<span>&#8203;</span>49345</li>
              <li>Whatsapp No: 63449345</li>

              <li>Email: <a href="mailto:iwannaplay@thecage.com.sg">iwannaplay<span>&#8203;</span>{"@" + "thecage.com.sg"}</a></li>
              <li>
                Main Corporate Address: 38 Jalan Benaan Kapal, Singapore 399635
              </li>
            </ul>
            <div className="pt-3 flex social-media">

              <a href="https://www.facebook.com/thecageSG" className="mx-2">
                <FaFacebookSquare className="w-6 h-6 " />
              </a>
              <a href="https://www.instagram.com/thecage_sg/" className="mx-2">
                <FaInstagram className="w-6 h-6 " />
              </a>

            </div>
          </div>
        </div>
      </div>
      <div className="flex max-w-full flex-col lg:flex-row justify-center items-center px-6 lg:px-20 py-6 footer-copyright">
        <div className="copyright">
          © Copyright 2025 The Cage | All Rights Reserved
        </div>
        <div className="poweredBy">Powered by The Cage</div>
      </div>
    </footer>
  );
};

export default Footer;
